export default {
  RELATIVE: 'relative',
  SPECIFIC: 'specific',
  BOTH: 'both',
};
